import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article-guide/page";
import ArticleVs from "../pages/article-vs/page";
import ArticlePricing from "../pages/article-pricing/page";
import ArticleTips from "../pages/article-tips/page";
import ArticleSafety from "../pages/article-safety/page";
import ArticleBeginners from "../pages/article-beginners/page";
import ArticleBestProducts from "../pages/article-best-products/page";
import ArticleAlternatives from "../pages/article-alternatives/page";
import Article2026 from "../pages/article-2026/page";
import ArticleSaveMoney from "../pages/article-save-money/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/acbuyspreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/acbuyspreadsheet-vs",
    element: <ArticleVs />,
  },
  {
    path: "/acbuyspreadsheet-pricing",
    element: <ArticlePricing />,
  },
  {
    path: "/acbuyspreadsheet-tips",
    element: <ArticleTips />,
  },
  {
    path: "/acbuyspreadsheet-safety",
    element: <ArticleSafety />,
  },
  {
    path: "/acbuyspreadsheet-beginners",
    element: <ArticleBeginners />,
  },
  {
    path: "/acbuyspreadsheet-best-products",
    element: <ArticleBestProducts />,
  },
  {
    path: "/acbuyspreadsheet-alternatives",
    element: <ArticleAlternatives />,
  },
  {
    path: "/acbuyspreadsheet-2026",
    element: <Article2026 />,
  },
  {
    path: "/acbuyspreadsheet-save-money",
    element: <ArticleSaveMoney />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;